var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83832 13.0036C4.58847 12.2535 5.60588 11.832 6.66675 11.832H13.3334C14.3943 11.832 15.4117 12.2535 16.1618 13.0036C16.912 13.7537 17.3334 14.7712 17.3334 15.832V17.4987C17.3334 17.8669 17.0349 18.1654 16.6667 18.1654C16.2986 18.1654 16.0001 17.8669 16.0001 17.4987V15.832C16.0001 15.1248 15.7191 14.4465 15.219 13.9464C14.7189 13.4463 14.0407 13.1654 13.3334 13.1654H6.66675C5.9595 13.1654 5.28123 13.4463 4.78113 13.9464C4.28103 14.4465 4.00008 15.1248 4.00008 15.832V17.4987C4.00008 17.8669 3.7016 18.1654 3.33341 18.1654C2.96522 18.1654 2.66675 17.8669 2.66675 17.4987V15.832C2.66675 14.7712 3.08818 13.7537 3.83832 13.0036Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.16732C8.52724 3.16732 7.33333 4.36123 7.33333 5.83398C7.33333 7.30674 8.52724 8.50065 10 8.50065C11.4728 8.50065 12.6667 7.30674 12.6667 5.83398C12.6667 4.36123 11.4728 3.16732 10 3.16732ZM6 5.83398C6 3.62485 7.79086 1.83398 10 1.83398C12.2091 1.83398 14 3.62485 14 5.83398C14 8.04312 12.2091 9.83398 10 9.83398C7.79086 9.83398 6 8.04312 6 5.83398Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffAccounts);
export default __webpack_public_path__ + "static/media/staff-accounts.b1df72c91dd45ea651dca9a1bdbfab5e.svg";
export { ForwardRef as ReactComponent };